import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

import MerchantOnlineBookingPricing from "views/MerchantOnlineBookingPricing/PricingList";
import CreateMerchantOnlineBookingPricing from "views/MerchantOnlineBookingPricing/Create";
import EditMerchantOnlineBookingPricing from "views/MerchantOnlineBookingPricing/Edit";
import DeleteMerchantOnlineBookingPricing from "views/MerchantOnlineBookingPricing/Delete";
import { token } from "functions/Helper";

const merchantOnlineBookingPricing = () => {
  let views = [];

  if (
    token["travelagent.online_pricings.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/MerchantOnlineBookingPricing/List",
      name: "M Online Booking Pricing",
      icon: MonetizationOnIcon,
      component: MerchantOnlineBookingPricing,
      layout: "/admin"
    });
  }

  return views;
};

const merchantOnlineBookingPricingHidden = () => {
  let views = [];

  if (
    token["travelagent.online_pricings.write"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views = views.concat([
      {
        path: "/MerchantOnlineBookingPricing/Create",
        name: "Create M Online Booking Pricing",
        component: CreateMerchantOnlineBookingPricing,
        layout: "/admin"
      },
      {
        path: "/MerchantOnlineBookingPricing/Edit",
        name: "Edit M Online Booking Pricing",
        component: EditMerchantOnlineBookingPricing,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      },
      {
        path: "/MerchantOnlineBookingPricing/Delete",
        name: "Delete M Online Booking Pricing",
        component: DeleteMerchantOnlineBookingPricing,
        layout: "/admin",
        params: [
          {
            name: "id"
          }
        ]
      }
    ]);
  }

  if (views.length > 0)
    return [
      {
        collapse: true,
        name: "BookingType Hidden",
        state: "bookingTypeHidden",
        hideInSidebar: true,
        views: views
      }
    ];
  return [];
};

export { merchantOnlineBookingPricing, merchantOnlineBookingPricingHidden };
